import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {EditableTextareaWithLinksComponent} from './editable-textarea-with-links.component';
import {ReactiveFormsModule} from '@angular/forms';


@NgModule({
  declarations: [
    EditableTextareaWithLinksComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  exports: [
    EditableTextareaWithLinksComponent
  ]
})
export class EditableTextareaWithLinksModule {
}
